import { render } from "./icon-weather.vue?vue&type=template&id=63dfdfed"
import script from "./icon-weather.vue?vue&type=script&lang=js"
export * from "./icon-weather.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__